var BookAppointmentCtrl = function ($rootScope, $scope, previousState, customerModelService, $log, SettingsConstants, $state, maintenanceModelService, apiService, loaderService, $q) {
    $scope.bookAppoimentInitLoader = loaderService.getOrCreate("bookAppoimentStart");
    $scope.availableTimesLoader = loaderService.getOrCreate("scheduledTime");
    $scope.bookAppoimentInitLoader.show('init');

    function getServiceOrder(serviceName) {
        var defaultOrder = -99999;
        if (!window.appSettings.servicesOrder || !window.appSettings.servicesOrder instanceof Array) {
            return defaultOrder
        }
        return window.appSettings.servicesOrder.indexOf(serviceName) === -1 ? defaultOrder : window.appSettings.servicesOrder.indexOf(serviceName);
    }

    // this controller servers 5 substates of
    // book appointment page, they are
    // 0 - vehicle updates page
    // 1 - customer concerns page
    // 2 - factory required
    // 3 - other and dialer recommended services
    // 4 - schedule
    // 5 - summary

    var servicesStates = [
        { name: 'bookappointment.updates', order: getServiceOrder('updates') },
        { name: 'bookappointment.concerns', order: getServiceOrder('concerns') },
        { name: 'bookappointment.required', order: getServiceOrder('required') },
        { name: 'bookappointment.recommended', order: getServiceOrder('recommended') }
    ]

    var internalStates = servicesStates
        .sort(function (el1, el2) {
            return el1.order - el2.order;
        })
        .map(function (el) {
            return el.name;
        })
        .concat([
            'bookappointment.schedule',
            'bookappointment.survey',
            'summary'
        ]);

    // Add appointment booking internal states to make accessable to other
    // application components
    $scope.internalStates = internalStates;

    // map for state names that should be outputed in header
    // of the application
    var statesNames = {
        'bookappointment.updates': appSettings.resources.Book_Appointment__Vehicle_Updates,
        'bookappointment.concerns': appSettings.resources.Book_Appointment__Customer_Сoncerns,
        'bookappointment.required': appSettings.resources.Book_Appointment__Factory_Required_Services,
        'bookappointment.recommended': appSettings.resources.Book_Appointment__Dealer_Recommended_Services,
        'bookappointment.schedule': appSettings.resources.Book_Appointment__Schedule,
        'bookappointment.survey': ''
    };

    var scheduledTime = customerModelService.getCurrentScheduledTime();
    if (scheduledTime) $scope.scheduledTime = scheduledTime;

    // list of ignored tabs by id
    var ignoredStates = $scope.ignoredStates = {};
    
    const recallsDisabledOrEmpty = !window.appSettings.enableRecalls || _.isEmpty(customerModelService.getMergedRecalls());
    const alertsDisabledOrEmpty = !window.appSettings.ossShowVehicleAlerts || _.isEmpty(customerModelService.getVehicleAlerts());

    if (recallsDisabledOrEmpty && alertsDisabledOrEmpty) ignoredStates[internalStates.indexOf('bookappointment.updates')] = true;
    if (!window.appSettings.displayFrsConfiguration) ignoredStates[internalStates.indexOf('bookappointment.required')] = true;
    if (!window.appSettings.displayConcernsConfiguration) ignoredStates[internalStates.indexOf('bookappointment.concerns')] = true;
    if (!window.appSettings.displayDrsConfiguration) ignoredStates[internalStates.indexOf('bookappointment.recommended')] = true;
    ignoredStates[internalStates.indexOf['bookappointment.survey']] = true;

    // set initial state number depend on if url has state name or not
    $scope.currentStateNumber = $state.current.name ? internalStates.indexOf($state.current.name) : 0;
    // if state number is ignore - find next "true" state
    while (ignoredStates[$scope.currentStateNumber]) $scope.currentStateNumber++;

    function checkState(stateNumber, cb) {
        if (internalStates[stateNumber] === 'bookappointment.schedule'
            && !customerModelService.getSelectedServicesAmount().amount
            && !window.appSettings.allowAppointmentWithoutServicesSelected) {
            $state.go('bookappointment.noservices');
        } else if (internalStates[stateNumber] === 'bookappointment.survey'){
            $state.go('summary');
        } else {
            cb.call(null);
        }
    }

    // go to the next substate
    $scope.next = function () {
        if ($scope.currentStateNumber == 5) {
            return;
        } else {
            checkState($scope.currentStateNumber + 1, function () {
                $scope.currentStateNumber++;
                if (ignoredStates[$scope.currentStateNumber]) return $scope.next();
                if ($scope.currentStateNumber > 1) $scope.disabledStates = {};
                $state.go(internalStates[$scope.currentStateNumber]);
            })
        }
    };

    $scope.isDisabledNextButton = function () {
        //disable "next" button if advisers and time is absent.
        if ($scope.currentStateNumber == 4) {
            //check if appropriate transportation option was selected
            if (!customerModelService.getCurrentTransportationOption() || !customerModelService.getCurrentTransportationOption().enabled) {
                return true;
            }
            //cehck if scheduled time set
            var scheduledTime = customerModelService.getCurrentScheduledTime();
            if (scheduledTime) {
                return false;
            } else {
                return true;
            }
        } else if ($scope.currentStateNumber === 5) {
            return true;
        }
    };

    // getStateDisplayNumber
    //
    // @param {number} stateIdx - index of a state
    //
    // @return {number} value to display state number
    //
    // @description
    // Method calculates the value of a state to be displayed in the list of tabs
    $scope.getStateDisplayNumber = function (stateIdx) {
        if (stateIdx < 0) throw('Invalid input');
        if (ignoredStates[stateIdx]) return -1;
        var count = 0;
        var i = stateIdx;
        while (i--)
            if (ignoredStates[i]) count++;
        return stateIdx + 1 - count;
    };

    $scope.disabledStates = {};

    function checkDisabledStates(stateIdx) {
        if (stateIdx < 2) {
            $scope.disabledStates[3] = true;
            $scope.disabledStates[4] = true;
        }
    }

    //function to set focus on first tab
    function setFocusOnFirstTab() {
        let selectedTab = 0;
        while (ignoredStates[selectedTab]) selectedTab++;
        $state.go(internalStates[selectedTab]);
    }

    // direct switch to state by presing on item at page header menu
    $scope.setState = function (stateNumber) {
        var isTargetStateDisabled = $scope.disabledStates[stateNumber] || $scope.bookAppoimentInitLoader.isShowed || $scope.bookAppoimentServicesLoader.isShowed || $scope.changeStateLoader.isShowed;
        //prevent change state if target state is disabled.
        if (isTargetStateDisabled) {
            return false;
        } else {
            checkState(stateNumber, function () {
                if (stateNumber > 1) $scope.disabledStates = {};
                $scope.currentStateNumber = stateNumber;
                $state.go(internalStates[$scope.currentStateNumber]);
            });
        }

        if ($scope.$root.maintenanceMenuIsPending)
            $scope.$root.stopGenerateMaintenanceMenu = true;

        $scope.$root.maintenanceMenuIsPending = false;
        $scope.$root.maintenanceMenuGetLinkError = false;
    };

    //getHeaderName
    //
    //@param {number} state index
    //
    //@return {string} header name
    //
    //@description
    //Get current header name regarding to state
    $scope.getHeaderName = function (stateIndex) {
        if (stateIndex > -1 && stateIndex < internalStates.length) {
            return statesNames[internalStates[stateIndex]];
        }
    };
    // getSelectedItemsAmount
    //
    // @return {object} selected items amount
    //  amount - total items amount
    //  price - total items price
    //
    // @description
    // Method returns object that contains information about all selected services
    // amount and their total price
    $scope.getSelectedItemsAmount = function () {
        return customerModelService.getSelectedServicesAmount();
    };
    //filterServices
    //
    //@param {Array} services
    //@param {String} filter string
    //@param {String} property value
    //
    //@return {Array} filtered array
    //
    //@description
    // Method filters given array by given property value if property value is not
    // set method will filter by name property. This method is using within controllers
    // of the child of this controller scope
    $scope.filterServices = function (servicesArray, filterString, propertyName) {
        propertyName = propertyName || 'name';
        // if filter is not set - nothing to filter
        // returning the existin array
        if (!filterString) {
            return servicesArray;
        }
        filterString = filterString.toLowerCase();
        return servicesArray.filter(function (el) {
            // if object within filtering array has not given
            // property consider this element like invalid and
            // filter it
            if (!el.hasOwnProperty(propertyName)) {
                return false;
            }
            var currentPropertyValue = el[propertyName].toLowerCase();
            return currentPropertyValue.indexOf(filterString) != -1;
        });
    };
    // listen to states changes to define current state index
    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        // workaround of no service error screen implementetion. In case of showing this error screen we shouldn't
        // override current state number
        if (toState.name === 'bookappointment.noservices') {
            return;
        }
        if (toState.name === 'bookappointment.survey') {
            statesNames['bookappointment.survey'] = toParams.name;
        }
        // typical behavior
        $scope.currentStateNumber = internalStates.indexOf(toState.name);
        if ($scope.currentStateNumber < internalStates.indexOf(fromState.name)) {
            $scope.back = true;
        } else {
            $scope.back = false;
        }
    });
    // isServiceRequiredState
    //
    //@return {Boolean} is current state 'services-required'
    //
    //@description
    // Method return if current state is 'bookappointment.noservices'
    $scope.isServiceRequiredState = function () {
        return $state.is('bookappointment.noservices');
    }
    //init()
    //
    //@description
    //Entru point into application client logic
    function init() {
        // reset maintenance menu link
        $scope.$emit('FactoryRequiredCtrl:changeInterval');

        $scope.bookAppoimentServicesLoader = loaderService.getOrCreate("bookAppoimentServices");

        var currentVehicle = customerModelService.getCurrentVehicle();
        // check if the vehicle was set on previous stages
        if (!currentVehicle) {
            $log.warn('Vehicle is not set. It is impossible to build intervals');
            return;
        }

        // check if vehicle has a maintenance period value
        var maintenance = currentVehicle.getMaintenance();
        if (!maintenance || !maintenance.period) {
            $log.warn('Maintenance period is not set. It is impossible to build intervals');
            return;
        }

        // get the odometer value that has been set on previous state
        var currentOdometerValue = currentVehicle.odometer;
        if (!currentOdometerValue) {
            $log.warn('Current odometer value not set. It might be possible if user forgot to set odometer on previous page of the application');
            return;
        }
        // get the maintenance period that has been set on previous state
        var selectedMaintenancePeriod = currentVehicle.getCurrentMaintenanceInterval();
        var currentAppointment = customerModelService.getCurrentAppointment();

        if (!selectedMaintenancePeriod) {
            // save the maintenance intervals into the model
            var maintenanceIntervals = maintenanceModelService.setMaintenanceIntervals(
                currentVehicle.getMaintenance().period,
                currentOdometerValue,
                currentVehicle.getMaintenance().enrollmentMileage,
                !currentAppointment // Not select interval by odometer
            );
            //get selected maintenance period
            selectedMaintenancePeriod = maintenanceModelService.getSelectedMaintenanceInterval(maintenanceIntervals);
        }
        // TODO Заглушка

        var servicesPromise;
        if (currentAppointment) servicesPromise = $q.when(customerModelService.getFactoryRequiredServices());
        else servicesPromise = maintenanceModelService.resolveFactoryRequiredServices(customerModelService.getCurrentVehicle(),
            selectedMaintenancePeriod.mileage, true);

        servicesPromise.then(function (factoryRequiredServices) {
            var currentFRS = customerModelService.getFactoryRequiredServices();
            var includedServices = [];

            _.remove(factoryRequiredServices, _.isNull);

            if (_.size(currentFRS)) {
                _.forEach(factoryRequiredServices, function (o) {
                    var service = _.find(currentFRS, { id: o.id });
                    if (service) {
                        includedServices.push(service);
                        o.selected = service.selected;
                        o.comment = service.comment;
                    } else {
                        o.selected = window.appSettings.displayFrsPreselected;
                    }
                });
                // in case if we have broken package we do not receive from api additional services expect
                // package in this case we should extend received data with services that user have selected
                if(currentFRS.length > factoryRequiredServices.length) {
                    factoryRequiredServices = factoryRequiredServices.concat(currentFRS.filter(function(cs){
                        return !_.find(includedServices, {id: cs.id});
                    }));
                }
                customerModelService.setFactoryRequiredServices(factoryRequiredServices, true);
            } else {
                customerModelService.setFactoryRequiredServices(factoryRequiredServices);
            }
            //reload frs into child controller
            $scope.$broadcast('bookAppoimentServicesCtrl:reloadFRS');
            var maintenanceIntervals = maintenanceModelService.getMaintenanceIntervals();
            var selectedMaintenancePeriod = maintenanceModelService.getSelectedMaintenanceInterval(maintenanceIntervals);

            // TODO Заглушка

            var drsPromise;
            if (currentAppointment) drsPromise = $q.when(customerModelService.getDealerRecommendedServices());
            else drsPromise = maintenanceModelService.resolveDealerRecommendedServices(customerModelService.getCurrentVehicle(), selectedMaintenancePeriod.mileage, true);

            return drsPromise;
        }).then(function (dealerRecommendedServices) {
            var currentDRS = customerModelService.getDealerRecommendedServices();
            if (_.size(currentDRS)) {
                _.forEach(dealerRecommendedServices, function (o) {
                    var service = _.find(currentDRS, { id: o.id });
                    if (service) {
                        o.selected = service.selected;
                        o.comment = service.comment;
                    } else {
                        o.selected = window.appSettings.displayFrsPreselected && o.intervalRecommended;
                    }
                });
                customerModelService.setDealerRecommendedServices(dealerRecommendedServices, true);
            } else {
                customerModelService.setDealerRecommendedServices(dealerRecommendedServices);
            }
            //reload drs into child controller
            $scope.$broadcast('bookAppoimentServicesCtrl:reloadDRS');
        })
            .finally(function () {
                $scope.bookAppoimentInitLoader.hide('init');
                //set focus on first tab except appointment edit case.
                if (previousState.name != 'summary') {
                    setFocusOnFirstTab();
                }
                // by default go to first substate
                var internalStatesIdx = 0;
                if ($state.current.name == 'bookappointment') {
                    // find not ignored state
                    while (ignoredStates[internalStatesIdx]) internalStatesIdx++;
                    //chek and disable some states if current state < 1
                    checkDisabledStates(internalStatesIdx);
                    //$state.go(internalStates[internalStatesIdx]);
                } else {
                    internalStatesIdx = internalStates.indexOf($state.current.name);
                    // find not ignored state state
                    while (ignoredStates[internalStatesIdx]) internalStatesIdx++;
                    while (ignoredStates[internalStatesIdx]) internalStatesIdx++;
                    //$state.go(internalStates[internalStatesIdx]);
                    //activate "Summary" button when redirected from "Summary" page.
                    // In case if Opcodes blocking enabled redirection to summary page around Schedule page disabled.
                    $scope.isActiveSummaryButton = true && !$scope.appSettings.opCodesBlockingEnabled;
                }
            });
    }

    //run the controller
    init();
};

BookAppointmentCtrl.$inject = ['$rootScope', '$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'maintenanceModelService', 'apiService', 'LoaderService', '$q'];

module.exports = BookAppointmentCtrl;
